import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import type { articleHeadlineHeaderFeaturesArticle$key } from "scmp-app/queries/__generated__/articleHeadlineHeaderFeaturesArticle.graphql";

import { Container } from "./styles";

export type HeaderFeaturesArticleHeadlineProps = HeaderFeatureCommonProps & {
  isMagazineStyle?: boolean;
};

export const HeaderFeaturesArticleHeadline: FunctionComponent<
  HeaderFeaturesArticleHeadlineProps
> = ({ isMagazineStyle = false, ...props }) => {
  const currentArticle = useAtomValue(currentArticleAtom);
  if (!currentArticle) return null;

  const data = readInlineData<articleHeadlineHeaderFeaturesArticle$key>(
    graphql`
      fragment articleHeadlineHeaderFeaturesArticle on Article @inline {
        headline
        socialHeadline
      }
    `,
    currentArticle,
  );

  const { headline, socialHeadline } = data ?? {};

  const displayHeadline = socialHeadline ?? headline ?? null;

  return (
    <Container $isMagazineStyle={isMagazineStyle} {...getResponsiveProps(props)}>
      {displayHeadline}
    </Container>
  );
};

HeaderFeaturesArticleHeadline.displayName = "HeaderFeaturesArticleHeadline";
